// @flow

import { Platform } from "react-native-web";

export default () => {
  const contentTheme = {
    flex: 1,
    flexBasis: Platform.OS === "web" ? "auto" : undefined,
    backgroundColor: 'transparent',
    'NativeBase.Segment': {
      borderWidth: 0,
      backgroundColor: 'transparent'
    }
  };

  return contentTheme;
};
